export const MfaStorageKey = "MFA_STORAGE_KEY";

export enum EmailConfirmationType {
  MAGIC_LINK = "MAGIC_LINK",
  PASSWORD_CREATE = "PASSWORD_CREATE",
  PASSWORD_RESET = "PASSWORD_RESET",
  MFA_CODE = "MFA_CODE",
}

export enum PasswordUpdateType {
  CREATE = "create",
  UPDATE = "update",
}
